import { AuthStatus, useAuthState } from '@packages/contexts/auth';
import { PageViewTracker } from '@web/core/google-analytics/page-view-tracker';
import { toGoogleAnalyticsUserTraits } from '@web/core/google-analytics/google-analytics.identity';
import { googleAnalyticsService } from '@web/services/singletons';
import { useEffect } from 'react';

/**
 * WEB-ONLY. Mounts any piece of Google Analytics wiring that has to live inside the React tree, such as
 * user identity, any ambient context sources, and SPA page-view tracking.
 *
 * Renders nothing visible.
 */
export function GoogleAnalyticsIntegration() {
    const { account, status } = useAuthState();
    /**
     * Attaches (or clears) the signed-in user on the analytics service once auth has settled. This is also what boots
     * the GTM container, so it has to run whether or not anybody is signed in.
     */
    useEffect(() => {
        const isAuthResolved = status === AuthStatus.Authenticated || status === AuthStatus.Unauthenticated;
        if (!isAuthResolved) {
            return;
        }

        const traits = toGoogleAnalyticsUserTraits(account);
        if (traits) {
            googleAnalyticsService.setUser(traits);
            return;
        }
        googleAnalyticsService.resetUser();
    }, [account, status]);

    return <PageViewTracker />;
}
